import { TFunction } from "i18next";

import { FilterField } from "~/features/filter";
import { useSubjectOptions } from "~/pages/Editor/ContestTerritories/hooks/useSubjectOptions";

export const contestTerritoriesFilterFields = (t: TFunction): FilterField[] => [
  {
    name: "date",
    type: "datePicker",
    label: t("contestTerritories.filters.date"),
  },
  {
    name: "geoPlaceId",
    type: "select",
    label: t("contestTerritories.filters.region"),
    optionsHook: useSubjectOptions,
  },
];
